import Vue from 'vue'
import Vuex from 'vuex'
import checkpoints from './modules/checkpoints'
import gpsdevices from './modules/gpsdevices'
import maintenances from './modules/maintenances'
import motorbikes from './modules/motorbikes'
import tracks from './modules/tracks'
import trips from './modules/trips'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    checkpoints,
    gpsdevices,
    maintenances,
    motorbikes,
    tracks,
    trips,
    user
  }
})

export default store